<template>
	<section v-if="!isMobile" :id="finalSection.id" :class="'section-cont relative ' + finalSection.sectionStyle">
		<div class="scrolly-bibliography stack-vertical">
			<p class="scrolly-bibliography-title font-subhead font-medium">{{$t('generic_riferimenti').toUpperCase()}}</p>
			<div class="scrolly-bibliography-cont grid-horizontal">
				<div class="scrolly-bibliography-stages stack-vertical">
					<div v-for="(stage, i) in stages.filter((el, i) => i > 0 && i < stages.length-1)" :class="'scrolly-bibliography-stage stack-horizontal pointer '+(isStageInactive(stage.id) ? 'inactive' : '')" @click="clickStageBibliography(stage.id)">
						<p class="font-bold capitalize-first scrolly-bibliography-stage-num">{{i+1}}</p>
						<base-icon name="detail"/>
						<p class="font-bold capitalize-first">{{stage.name[$i18n.locale]}}</p>
						<base-icon name="arrow-sm-right-1" class="scrolly-bibliography-right-arrow"/>
					</div>
				</div>
				<div class="scrolly-bibliography-contents stack-vertical">
					<div class="scrolly-bibliography-content stack-vertical">
						<div v-if="currentBibliographyStage" class="scrolly-bibliography-b stack-vertical">
							<p class="font-caption-maiusc font-medium scrolly-bibliography-subtitle">{{$t('scrolly_bibliografia')}}</p>
							<div v-for="b in currentBibliographyStage.documentation.bibliography.filter(el => utils.markdownToHtml(biOrMonoLang(el.text)).length > 0)">
								<div class="bibliography-item" v-html="utils.markdownToHtml(biOrMonoLang(b.text))"></div>
							</div>
							<p v-if="currentBibliographyStage.documentation.sitography.length" class="font-caption-maiusc font-medium scrolly-bibliography-subtitle">{{$t('scrolly_sitografia')}}</p>
							<div v-for="b in currentBibliographyStage.documentation.sitography.filter(el => utils.markdownToHtml(biOrMonoLang(el.text)).length > 0)">
								<div class="bibliography-item bibliography-link"><a :href="b.link" target="_blank" v-html="utils.markdownToHtml(biOrMonoLang(b.text))"></a></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
	<section v-else :id="finalSection.id" :class="'section-cont relative section-bibliography ' + finalSection.sectionStyle">
		<div class="scrolly-bibliography-mobile stack-vertical">
			<p class="scrolly-bibliography-mobile-title font-medium">{{$t('generic_riferimenti').toUpperCase()}}</p>
			<div class="bibliography-mobile-cont stack-vertical">
				<div v-for="(stage, i) in stages.filter((el, i) => i > 0 && i < stages.length-1)" class="bibliography-mobile-item stack-vertical">
					<div class="bibliography-mobile-stage stack-horizontal" data-align="center" @click="clickStageBibliography(stage.id)">
						<h2 class="bibliography-mobile-stage-number font-bold">{{i+1}}</h2>
						<p class=" bibliography-mobile-stage-title font-bold capitalize-first">{{stage.name[$i18n.locale]}}</p>
						<base-icon name="arrow-sm-down-1" />
					</div>
					<div class="bibliography-mobile-voices stack-vertical" v-if="currentBibliographyStage && currentBibliographyStage.id == stage.id">
						<p class="font-caption-maiusc font-medium scrolly-bibliography-subtitle">{{$t('scrolly_bibliografia')}}</p>
						<div v-for="b in currentBibliographyStage.documentation.bibliography.filter(el => utils.markdownToHtml(biOrMonoLang(el.text)).length > 0)" class="scrolly-bibliography-mobile-voice">
							<div class="bibliography-item" v-html="utils.markdownToHtml(biOrMonoLang(b.text))"></div>
						</div>
						<p v-if="currentBibliographyStage.documentation.sitography.length" class="font-caption-maiusc font-medium scrolly-bibliography-subtitle">{{$t('scrolly_sitografia')}}</p>
						<div v-for="b in currentBibliographyStage.documentation.sitography.filter(el => utils.markdownToHtml(biOrMonoLang(el.text)).length > 0)">
							<div class="bibliography-item bibliography-link"><a :href="b.link" target="_blank" v-html="utils.markdownToHtml(biOrMonoLang(b.text))"></a></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script type="text/javascript">
	
import utils from '@js/utils.js';
import { mapGetters } from 'vuex';
import cloneDeep from 'lodash.clonedeep';

export default {
	name: 'InterfaceScrollyBibliographySection',
	props: {
		stages: {
			type: Array,
			default: []
		},
		finalSection: {
			type: Object,
			default: null
		}
	},
	data() {
		return {
			currentBibliographyStage: null,
			utils
		}
	},
	computed: {
		...mapGetters(['isMobile']),
	},
	methods: {
		clickStageBibliography(stageId) {
			if(this.isMobile) {
				if(!this.currentBibliographyStage) {
					this.currentBibliographyStage = this.stages.find(el => el.id == stageId);
					return
				}
				if(this.currentBibliographyStage.id == stageId) {
					this.currentBibliographyStage = null;
				}else {
					this.currentBibliographyStage = this.stages.find(el => el.id == stageId);
				}
			}else {
				this.currentBibliographyStage = this.stages.find(el => el.id == stageId);
				document.querySelector('.scrolly-bibliography-b').scrollTop = 0
			}
		},
		isStageInactive(stageId) {
			return this.currentBibliographyStage ? this.currentBibliographyStage.id !== stageId : false
		},
		openMobileStage(id) {
			// console.log('openMobileStage', id)
		},
		async inhibitScrollBibliographyList() {
			await utils.isElLoaded('.scrolly-bibliography-b')
			document.querySelector('.scrolly-bibliography-b').onwheel = e => {
				e.stopPropagation()
			}
		},
		biOrMonoLang(item) {
			// console.log('item', cloneDeep(item))
			return (typeof item == 'object' ? (item[this.$i18n.locale] ? item[this.$i18n.locale] : '') : item)
		}
	},
	mounted() {
		if(!this.isMobile) {
			this.currentBibliographyStage = this.stages[1]
			this.inhibitScrollBibliographyList()
		}
	}
}

</script>
